var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Tooltip } from 'modules/Tooltip';
import { IconButtonContainer } from './styled';
export const IconButton = forwardRef((props, ref) => {
    const { children, 'aria-label': ariaLabel = '', tooltip, as } = props, rest = __rest(props, ["children", 'aria-label', "tooltip", "as"]);
    /** `type="button"` only means something on a `<button>`, so it is dropped once `as` re-targets the element. */
    const type = as ? undefined : 'button';
    return (<Tooltip disabled={!ariaLabel} title={ariaLabel} ref={ref} {...tooltip}>
      <IconButtonContainer as={as} aria-label={ariaLabel} type={type} {...rest}>
        {children}
      </IconButtonContainer>
    </Tooltip>);
});
